
interface Props {
  onHover: () => void;
  onHoverOut: () => void;
  onClick: () => void;
  icon: string;
  label: string;
  isHovering: boolean;
}

const FloatingButton = ({
  onHover,
  onHoverOut,
  onClick,
  icon,
  label,
  isHovering,
}: Props) => {
  return (
    <div
      className="fixed right-0 top-40 flex items-center overflow-hidden"
      style={{
        width: isHovering ? "165px" : "50px",
        transition: "width 0.5s ease",
      }}
      onMouseEnter={onHover}
      onMouseLeave={onHoverOut}
    >
      <button
        onClick={onClick}
        className="flex items-center bg-blue-500 p-2 shadow-lg w-full justify-start"
      >
        <img src={icon} alt="Live Assistance" className="h-8 w-8" />
        <span
          className="ml-2 overflow-hidden"
          style={{
            opacity: isHovering ? 1 : 0,
            transition: "opacity 0.5s ease",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </span>
      </button>
    </div>
  );
};

export default FloatingButton;
export {};
